import { RouterModule, Routes } from '@angular/router';
import { PermissionsGuard } from '@akebono/core';
import { ProtectedGuard } from 'ngx-auth';
import { PERMISSION_LOTS } from '../../const';
import { NgModule } from '@angular/core';
import { CheckProductionDatesComponent } from './components/check-production-dates/check-production-dates.component';

const routes: Routes = [
  {
    path: 'check-production-dates',
    component: CheckProductionDatesComponent,
    canActivate: [PermissionsGuard, ProtectedGuard],
    data: {
      permissions: [PERMISSION_LOTS],
      breadcrumb: 'CheckProductionDates',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CheckProductionDatesRoutingModule {}
